module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/payment-card/error-payment-card-a43586d607516685942610ac212cb92f.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/payment-card/error-payment-card.svg
// module id = sWa7
// module chunks = 24